import React, { Component, useRef } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './Controls.css';
import Seekbar from './Seekbar';
import Help from './Help';
import Utility from '../../../Utility';
import { connect } from 'react-redux';

import { ReactComponent as IconBackward } from './ControlsIcons/backward_10.svg';
import { ReactComponent as IconPlay } from './ControlsIcons/play.svg';
import { ReactComponent as IconPause } from './ControlsIcons/pause.svg';
import { ReactComponent as IconForward } from './ControlsIcons/forward_10.svg';
import { ReactComponent as IconVolumeNone } from './ControlsIcons/volume_none.svg';
import { ReactComponent as IconVolumeFull } from './ControlsIcons/volume_full.svg';
import { ReactComponent as IconVolumeSmall } from './ControlsIcons/volume_small.svg';

import { ReactComponent as IconCC } from './ControlsIcons/cc.svg';
import { ReactComponent as IconThumbnails } from './ControlsIcons/thumbnails.svg';
import { ReactComponent as IconFullscreenEnter } from './ControlsIcons/fullscreen_enter.svg';
import { ReactComponent as IconFullscreenExit } from './ControlsIcons/fullscreen_exit.svg';
import { ReactComponent as IconSettings } from './ControlsIcons/settings.svg';

let spaceBarHeld = false;

class Controls extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mutedVolume: 0,
			activelySliding: false,
			volumeExpanded: false,
			rateExpanded: false,
			thumbselectorExpanded: false,
			settingsselectorExpanded: false,
			sliderValue: this.props.data.volume,
			showHelp: false,
			previousPlaybackRate: 1
		};
	}

	componentDidUpdate() {
		// Check to see if we're sliding - if not set the volume value
		if(this.state.activelySliding === false && this.state.sliderValue !== this.props.data.volume) {
			this.setState({
				sliderValue: this.props.data.volume
			});
		}
	}

	componentDidMount() {
		document.addEventListener('keydown', this.keydownHandler);
		document.addEventListener('keyup', this.keyupHandler);
		document.addEventListener('click', this.closeHelp);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.keydownHandler);
		document.removeEventListener('keyup', this.keyupHandler);
		document.removeEventListener('click', this.closeHelp);

		// Clean up timeout
		if (this.spaceBarTimeout) {
			clearTimeout(this.spaceBarTimeout);
		}
	}

	logEventHandler = (event, params = {}) => {
		Utility.logUserInteraction(event, params, { current_time: this.props.dynamic.currentTime });
	}

	keyupHandler = (ev) => {
		// Handle space bar release
		if (ev.keyCode === 32) {
			ev.preventDefault();
			this.handleSpaceBarRelease();
		}
	}

	handleSpaceBarRelease = () => {
		if (!spaceBarHeld) {
			if (this.spaceBarTimeout) {
				clearTimeout(this.spaceBarTimeout);
				this.spaceBarTimeout = null;
			}

			// This was a momentary press - trigger play/pause
			this.playpauseclickHandler();
		} else {
			spaceBarHeld = false;
			// This was a hold - restore previous playback rate
			this.logEventHandler('player_change_playback_rate', { playback_rate: this.state.previousPlaybackRate });
			this.props.trigger('setPlaybackRate', this.state.previousPlaybackRate);
		}
	}

	handleSpaceBarPress = () => {
		if (!spaceBarHeld) {
			// Store current playback rate
			this.setState({
				previousPlaybackRate: this.props.data.playbackRate
			});

			// Set a timeout to detect if this is a momentary press vs hold
			this.spaceBarTimeout = setTimeout(() => {
				spaceBarHeld = true;

				// If we reach this timeout, it means the space bar is being held
				// Set playback rate to 2x
				this.logEventHandler('player_change_playback_rate', { playback_rate: 2 });

				this.props.trigger('setPlaybackRate', 2);
				// Make sure we are playing
				this.props.trigger('play');
			}, 300); // 300ms threshold to distinguish between press and hold
		}
		// If already held, do nothing (prevent multiple triggers)
	}

	keydownHandler = (ev) => {
		var target = ev.target || ev.srcElement;

		// if a modifier key is pressed, and they aren't pressing ?
		if ((ev.shiftKey || ev.ctrlKey || ev.altKey || ev.metaKey) && ev.keyCode !== 191) {
			return;
		}

		if (target) {
			if (target.tagName === 'INPUT' && ev.keyCode !== 27) { return; }
			if (target.className === 'editable-word') {
				if (ev.keyCode === 13) {
					ev.preventDefault();
				}

				return;
			}
			if (target.className === 'editable-line') {
				if (ev.keyCode === 13) {
					ev.preventDefault();
				}

				return;
			}
		}

		switch (ev.keyCode) {
			case 27: // ESCAPE
				if (this.state.showHelp === true) {
					this.closeHelp(null);
				} else {
					this.closeTranscript();
				}
				break;
			case 32: // SPACE
				ev.preventDefault();
				this.handleSpaceBarPress();
				break;
			case 81: // q
				if (this.props.data.supportsThumbnails) {
					Utility.emit('player.previousThumbnail');
				}
				break;
			case 87: // w
				if (this.props.data.supportsThumbnails) {
					Utility.emit('player.nextThumbnail');
				}
				break;
			case 37: // ←
			case 74: // j
				// When the volume buttons have focus
				if (document.activeElement.classList.contains('controls-volume-btn') || document.activeElement.classList.contains('volume-slider')) {
					this.volumeDown();
				} else {
					this.backclickHandler();
				}

				ev.preventDefault();
				ev.stopPropagation();
				break;
			case 39: // →
			case 75: // k
				// When the volume buttons have focus
				if (document.activeElement.classList.contains('controls-volume-btn') || document.activeElement.classList.contains('volume-slider')) {
					this.volumeUp();
				} else {
					this.forwardclickHandler();
				}

				ev.preventDefault();
				ev.stopPropagation();
				break;
			case 38: // ↑
				this.volumeUp();
				break;
			case 40: // ↓
				this.volumeDown();
				break;
			case 67: // c
				this.toggleControls();
				break;
			case 70: // f
				this.fullscreenclickHandler();
				break;
			case 77: // m
				this.volumebuttonclickHandler(); // toggle mute
				break;
			case 82: // r
				this.rateclickHandler();
				break;
			case 83: // s
				if (this.props.data.supportsCaptions) {
					this.captionsclickHandler();
				}
				break;
			case 84: // t
				if (this.props.data.supportsThumbnails) {
					this.toggleThumbnails();
				}
				break;
			case 89: // y
				if (this.props.data.supportsThumbnails) {
					this.thumbnailclickHandler();
				}
				break;
			case 72: // h
				this.helpclickHandler();
				break;
			case 191: // ?
				if (ev.shiftKey) {
					this.helpclickHandler();
				}
				break;
			case 219: // [
				if (this.props.data.supportsWhiteboard) {
					this.shiftWhiteboardLeft();
				}
				break;
			case 221: // ]
				if (this.props.data.supportsWhiteboard) {
					this.shiftWhiteboardRight();
				}
				break;
			case 49: // 1
			case 50: // 2
			case 51: // 3
			case 52: // 4
			case 53: // 5
			case 54: // 6
			case 55: // 7
				this.toggleSource(ev.keyCode - 49);
				break;
			default:
				// do nothing
		}
	}

	toggleSource = (index) => {
		// TODO: merge into single routine at the App? level
		var tempVisiblePresets = JSON.parse(JSON.stringify(this.props.data.visiblePresets));

		// Determine which source this belongs to - if any
		var stageLength = this.props.data.visiblePresets.stage.length,
			whiteboardLength = this.props.data.visiblePresets.whiteboard.length;

		if (index < stageLength) {
			// stage switcher
			tempVisiblePresets.stage[index].visible = !tempVisiblePresets.stage[index].visible;

			this.props.updatePlayerState({
				visiblePresets: tempVisiblePresets
			});
		} else if (index < stageLength + whiteboardLength) {
			// whiteboard switcher
			index = index - stageLength;

			for (var i = tempVisiblePresets.whiteboard.length - 1; i >= 0; i--) {
				if (i === index) {
					// Toggle current whiteboard display
					tempVisiblePresets.whiteboard[i].visible = !tempVisiblePresets.whiteboard[i].visible;
				} else {
					// Hide all others
					tempVisiblePresets.whiteboard[i].visible = false;
				}
			}

			this.props.updatePlayerState({
				visiblePresets: tempVisiblePresets
			});
		}
	}

	toggleThumbnails = () => {
		if (this.props.data.thumbnails) {
			this.logEventHandler('player_hide_thumbs');
		} else {
			this.logEventHandler('player_show_thumbs');
		}

		this.props.updatePlayerState({
			thumbnails: !this.props.data.thumbnails
		});
	}

	toggleControls = () => {
		if (this.props.data.controls) {
			this.logEventHandler('player_hide_controls');
		} else {
			this.logEventHandler('player_show_controls');
		}

 		this.props.updatePlayerState({
			controls: !this.props.data.controls
		});
	}

	backclickHandler = () => {
		this.logEventHandler('player_go_backward_10_seconds');
		this.props.trigger('backward');
	}

	forwardclickHandler = () => {
		this.logEventHandler('player_go_forward_10_seconds');
		this.props.trigger('forward');
	}

	playpauseclickHandler = () => {
		this.props.trigger('playpause');
	}

	hasProcessingCaptions = () => {
		return this.props.data.recording.info.captionStatus === 'processing';
	}

	hasCaptions = () => {
		return this.props.data.recording.info.captions.length > 0;
	}

	captionsclickHandler = (ev) => {
		if (this.hasCaptions()) {
			if (this.props.data.captions) {
				this.logEventHandler('player_hide_captions');
			} else {
				this.logEventHandler('player_show_captions');
			}
		}

		this.props.trigger('toggleCaptions');
	}

	fullscreenclickHandler = (ev) => {
		Utility.emit('player.togglefullscreen');
	}

	shiftWhiteboardLeft = (ev) => {
		Utility.emit('player.shiftwhiteboardleft');
	}

	shiftWhiteboardRight = (ev) => {
		Utility.emit('player.shiftwhiteboardright');
	}

	seekHandler = (value) => {
		this.props.trigger('seekonly', value);
		Utility.logUserInteractionNoGA('player_seeked', {}, { current_time: value });
	}

	isMuted() {
		if (this.props.data.volume > 0) {
			return false;
		}

		return true;
	}

	volumeUp = () => {
		var targetVolume = 0;
		let originalVolume = this.props.data.volume;

		if (this.isMuted() === true) {
			if (this.state.mutedVolume > 0) {
				// It was muted, so restore the volume and increase a bit
				targetVolume = this.state.mutedVolume + .1;

				this.setState({
					mutedVolume: 0
				});
			} else {
				// We don't have a value for mutedVolume, so it's likely the audio was dragged to 0 intentionally
				targetVolume = .1;
			}
		} else {
			targetVolume = this.props.data.volume + .1;
		}

		targetVolume = Math.min(1, targetVolume);

		if (targetVolume !== originalVolume) {
			if (originalVolume !== 0) {
				this.logEventHandler('player_change_volume');
			}
		}

		this.props.trigger('setVolume', targetVolume);
	}

	volumeDown = () => {
		var targetVolume = 0;
		let originalVolume = this.props.data.volume;

		if (this.isMuted() === true) {
			if (this.state.mutedVolume > 0) {
				// It was muted, so restore the volume and decrease a bit
				targetVolume = this.state.mutedVolume - .1;

				this.setState({
					mutedVolume: 0
				});
			} else {
				// We don't have a value for mutedVolume, so it's likely the audio was dragged to 0 intentionally
				targetVolume = 0;
			}
		} else {
			targetVolume = this.props.data.volume - .1;
		}

		targetVolume = Math.max(0, targetVolume);

		if (targetVolume !== originalVolume) {
			if (targetVolume !== 0) {
				this.logEventHandler('player_change_volume');
			}
		}

		this.props.trigger('setVolume', targetVolume);
	}

	volumebuttonclickHandler = () => {
		if (this.isMuted() === true) {
			if (this.state.mutedVolume > 0) {
				this.props.trigger('setVolume', this.state.mutedVolume);
			} else {
				this.props.trigger('setVolume', 1);
			}

			this.setState({
				mutedVolume: 0
			});
		} else {
			this.setState({
				mutedVolume: this.props.data.volume
			});

			this.props.trigger('setVolume', 0);
		}
	}

	volumeslideronBeforeChangeHandler = () => {
		this.setState({
			activelySliding: true
		});
	}

	volumesliderchangeHandler = (value) => {
 		Utility.localStorageSet(this.props.data.recording.recordingkey + '.volume', value);
		this.props.trigger('setVolume', value);
		this.setState({
			sliderValue: value
		});
	}

	volumeslideronAfterChangeHandler = () => {
		this.setState({
			activelySliding: false
		});

		this.logEventHandler('player_change_volume');
	}

	expandVolumeSlider = () => {
		this.setState({
			volumeExpanded: true
		});
	}

	collapseVolumeSlider = () => {
		this.setState({
			volumeExpanded: false
		});
	}

	rateclickHandler = () => {
		let playbackRate = this.props.data.playbackRate;

		if (playbackRate >= 2) {
			playbackRate = 0;
		}

		this.logEventHandler('player_change_playback_rate', { playback_rate: this.snapToPresetRate(playbackRate) });
		this.props.trigger('setPlaybackRate', this.snapToPresetRate(playbackRate));
	}

	ratedirectclickHandler = (rate) => {
		this.logEventHandler('player_change_playback_rate', { playback_rate: rate });
		this.props.trigger('setPlaybackRate', rate);
	}

	expandRateSelector = () => {
		this.setState({
			rateExpanded: true
		});
	}

	collapseRateSelector = () => {
		this.setState({
			rateExpanded: false
		});
	}

	thumbnailclickHandler = () => {
		if (this.props.data.thumbnails === false) {
			// Show if hidden
			this.logEventHandler('player_show_thumbs');
			this.props.updatePlayerState({
				thumbnails: true
			});
		} else if (this.props.data.enabledPresets.thumbnailChoices.length === 1) {
			// Hide if there is just one set of thumbnails
			this.logEventHandler('player_hide_thumbs');
			this.props.updatePlayerState({
				thumbnails: false
			});
		} else {
			// Cycle through thumbnails
			var currentIndex = 0;

			for (var i = 0; i < this.props.data.enabledPresets.thumbnailChoices.length; i++) {
				if (this.props.data.selectedThumbnails[0] === this.props.data.enabledPresets.thumbnailChoices[i][0] &&
					this.props.data.selectedThumbnails[1] === this.props.data.enabledPresets.thumbnailChoices[i][1]
				) {
					currentIndex = i;
					break;
				}
			}

			currentIndex++;

			if (currentIndex > this.props.data.enabledPresets.thumbnailChoices.length-1) {
				currentIndex = 0;
			}

			this.logEventHandler('player_switch_thumbs', { thumbnail_type: this.props.data.enabledPresets.thumbnailChoices[currentIndex][2] } );
			this.props.updatePlayerState({
				selectedThumbnails: this.props.data.enabledPresets.thumbnailChoices[currentIndex]
			});
		}
	}

	thumbnailsourceclickHandler = (currentIndex) => {
		this.logEventHandler('player_switch_thumbs', { thumbnail_type: this.props.data.enabledPresets.thumbnailChoices[currentIndex][2] } );
	}

	expandThumbSelector = () => {
		this.setState({
			thumbselectorExpanded: true
		});
	}

	collapseThumbSelector = () => {
		this.setState({
			thumbselectorExpanded: false
		});
	}

	mainsettingsclickHandler = () => {
		console.log('mainsettingsclickHandler');
		let newIndex = this.props.data.currentProduct;
		newIndex++;

		if (newIndex >= this.props.data.products.length) {
			newIndex = 0;
		}

		Utility.emit('player.product.change', {
			currentTime: this.props.dynamic.currentTime,
			productIndex: newIndex
		});
	}

	settingsclickHandler = (index) => {
		if (index >= 0) {
			Utility.emit('player.product.change', {
				currentTime: this.props.dynamic.currentTime,
				productIndex: index
			});
		}
	}

	expandSettingsSelector = () => {
		this.setState({
			settingsselectorExpanded: true
		});
	}

	collapseSettingsSelector = () => {
		this.setState({
			settingsselectorExpanded: false
		});
	}

	helpclickHandler = () => {
		this.setState({
			showHelp: !this.state.showHelp
		}, () => {
			if (this.state.showHelp === true) {
				document.documentElement.classList.add('show-help');
			} else {
				document.documentElement.classList.remove('show-help');
			}
		});
	}

	closeHelp = (ev) => {
		if (ev && ev.target.classList.contains('controls-help-btn')) {
			return;
		}

		if (this.state.showHelp === true) {
			this.setState({
				showHelp: false
			}, () => {
				document.documentElement.classList.remove('show-help');
			});
		}
	}

	closeTranscript = () => {
		if (this.props.data.search === true) {
			this.props.updatePlayerState({ search: false });
		}
		if (this.props.data.transcript === true) {
			this.props.updatePlayerState({
				transcript: false
			});
		}
	}

	snapToPresetRate(value) {
		if (value < 0.8) {
			return 0.8;
		} else if (value < 1) {
			return 1;
		} else if (value < 1.2) {
			return 1.2;
		} else if (value < 1.5) {
			return 1.5;
		} else if (value <= 2) {
			return 2;
		}
	}

	render() {
		let playButtonClasses = ['controls-play-pause-btn'];

		if (!this.props.data.paused) {
			playButtonClasses.push('controls-play-pause-btn-playing');
		}

		let playbackRate = this.props.data.playbackRate,
			playbackRateButtonText = '';

		if (playbackRate > 1.51) {
			playbackRateButtonText = '2x';
		} else if (playbackRate > 1.21) {
			playbackRateButtonText = '1.5x';
		} else if (playbackRate > 1) {
			playbackRateButtonText = '1.2x';
		} else if (playbackRate > 0.81) {
			playbackRateButtonText = '1x';
		} else {
			playbackRateButtonText = '0.8x';
		}

		let volumeContainerClass = 'controls-slider controls-volume';

		if (this.state.activelySliding === true || this.state.volumeExpanded) {
			volumeContainerClass += ' controls-slider-active';
		}

		let volume = this.props.data.volume;

		var volumeIcon = <IconVolumeFull />;

	    if (volume > 0.5) {
			// Do nothing
		} else if (volume <= 0.5 && volume > 0) {
			volumeIcon = <IconVolumeSmall />;
		} else {
			volumeIcon = <IconVolumeNone />;
		}

		let captionButtonClass = 'controls-captions-btn';

		if (this.props.data.captions) {
			captionButtonClass += ' controls-captions-btn-visible';
		}

		var controlsClass = 'controls';

		if (!this.props.data.controls) {
			controlsClass += ' controls-compact';
		}

		let thumbselectorClass = 'controls-flyup-menu-container';

		if (this.state.thumbselectorExpanded) {
			thumbselectorClass += ' expanded';
		}

		let rateClass = 'controls-slider controls-playback-rate';

		if (this.state.rateExpanded) {
			rateClass += ' expanded';
		}

		let settingsselectorClass = 'controls-settings controls-flyup-menu-container';

		if (this.state.settingsselectorExpanded) {
			settingsselectorClass += ' expanded';
		}

		return (
			<div className={controlsClass}>
				{ this.state.showHelp ? <Help data={this.props.data} /> : null }
				<div className="controls-first-row">
					<Seekbar data={this.props.data} seekHandler={this.seekHandler} />
				</div>
				<div className="controls-second-row">
				  <div className="controls-left">
					<ControlButton tabIndex="0" className="controls-back-btn" title="Go backward 10 seconds (← or j)" actionhandler={this.backclickHandler}>
						<IconBackward />
					</ControlButton>
					<ControlButton tabIndex="0" className={ playButtonClasses.join(' ') } title="Play/Pause (SPACE)" actionhandler={this.playpauseclickHandler}>
						{ this.props.data.paused ? <IconPlay /> : <IconPause /> }
					</ControlButton>
					<ControlButton tabIndex="0" className="controls-forward-btn" title="Go forward 10 seconds (→ or k)" actionhandler={this.forwardclickHandler}>
						<IconForward />
					</ControlButton>
					<div className={volumeContainerClass} onFocus={this.expandVolumeSlider} onBlur={this.collapseVolumeSlider}>
						<ControlButton className="controls-slider-btn controls-volume-btn" title="Adjust volume (&uarr;/&darr;), Mute (m)" actionhandler={this.volumebuttonclickHandler}>
							{volumeIcon}
						</ControlButton>
						<Slider
							prefixCls="volume-slider rc-slider"
							onBeforeChange={this.volumeslideronBeforeChangeHandler}
							onChange={this.volumesliderchangeHandler}
							onAfterChange={this.volumeslideronAfterChangeHandler}
							ariaLabelForHandle={"Adjust Volume"}
							max={1}
							value={this.state.sliderValue}
							step={.01}
							keyboard={false}
						/>
					</div>
					<div className={rateClass} onFocus={this.expandRateSelector} onBlur={this.collapseRateSelector}>
						<ControlButton tabIndex="0" className="controls-playback-rate-btn controls-text-btn" title="Cycle through playback rates (r)" actionhandler={this.rateclickHandler}>
							{playbackRateButtonText}
						</ControlButton>
						<ControlButton tabIndex="0" className="controls-playback-rate-btn controls-text-btn controls-secondary-button" selected={playbackRateButtonText === '0.8x'} title="Adjust playback rate to 0.8 times speed" actionhandler={this.ratedirectclickHandler} actionValue={.8}>
							0.8x
						</ControlButton>
						<ControlButton tabIndex="0" className="controls-playback-rate-btn controls-text-btn controls-secondary-button" selected={playbackRateButtonText === '1x'} title="Adjust playback rate to 1 times speed" actionhandler={this.ratedirectclickHandler} actionValue={1}>
							1x
						</ControlButton>
						<ControlButton tabIndex="0" className="controls-playback-rate-btn controls-text-btn controls-secondary-button" selected={playbackRateButtonText === '1.2x'} title="Adjust playback rate to 1.2 times speed" actionhandler={this.ratedirectclickHandler} actionValue={1.2}>
							1.2x
						</ControlButton>
						<ControlButton tabIndex="0" className="controls-playback-rate-btn controls-text-btn controls-secondary-button" selected={playbackRateButtonText === '1.5x'} title="Adjust playback rate to 1.5 times speed" actionhandler={this.ratedirectclickHandler} actionValue={1.5}>
							1.5x
						</ControlButton>
						<ControlButton tabIndex="0" className="controls-playback-rate-btn controls-text-btn controls-secondary-button" selected={playbackRateButtonText === '2x'} title="Adjust playback rate to 2 times speed" actionhandler={this.ratedirectclickHandler} actionValue={2}>
							2x
						</ControlButton>
					</div>

					<FormattedTime data={this.props.data} />
				  </div>
				  <div className="controls-right">
					<ControlButton tabIndex="0" className="controls-help-btn controls-text-btn" title="Show keyboard shortcuts (h or ?)" actionhandler={this.helpclickHandler}>
						?
					</ControlButton>

					{ this.hasProcessingCaptions() ? <ControlButton tabIndex="0" className={captionButtonClass} disabled={true} tooltip="Captions are processing and can take up to 12 hours" actionhandler={this.captionsclickHandler}><IconCC /></ControlButton> : null }
					{ this.hasCaptions() ? <ControlButton tabIndex="0" className={captionButtonClass} title="Toggle Captions (s)" actionhandler={this.captionsclickHandler}><IconCC /></ControlButton> : null }

					{ this.props.data.supportsThumbnails > 0 ?
					<div className={thumbselectorClass} onFocus={this.expandThumbSelector} onBlur={this.collapseThumbSelector}>
						<ControlButton tabIndex="0" className="controls-thumbnails-btn" title="Hide/show (t) thumbnails, Cycle (y)" actionhandler={this.thumbnailclickHandler}>
							<IconThumbnails />
						</ControlButton>

						{this.props.data.enabledPresets.thumbnailChoices.length > 1 ?
						<div className="controls-flyup-menu">
							{this.props.data.enabledPresets.thumbnailChoices.length > 1 ? this.props.data.enabledPresets.thumbnailChoices.map((choice, index) => {
								return(<FlyoutThumbnailButton tabIndex="0" data={this.props.data} key={index} index={index} choice={choice} updatePlayerState={this.props.updatePlayerState} actionhandler={this.thumbnailsourceclickHandler}>{choice[2]}</FlyoutThumbnailButton>);
							}) : null }
							<FlyoutThumbnailButton data={this.props.data} showThumbnails={this.props.data.thumbnails} updatePlayerState={this.props.updatePlayerState} actionhandler={this.toggleThumbnails}>
								{ this.props.data.thumbnails ? 'Hide' : 'Show' } Thumbnails
							</FlyoutThumbnailButton>
						</div> : null }
					</div> : null
					}

					{ this.props.data.browsercapabilities.fullscreen ? <ControlButton tabIndex="10" className="controls-fullscreen-btn" title="Toggle fullscreen mode (f)" actionhandler={this.fullscreenclickHandler}>
						{ this.props.data.fullscreen ? <IconFullscreenExit /> : <IconFullscreenEnter /> }
					</ControlButton> : null }

					{ this.props.data.products.length > 1 ?
						<div className={settingsselectorClass} onFocus={this.expandSettingsSelector} onBlur={this.collapseSettingsSelector}>
							<ControlButton className="controls-settings-btn" title="Settings Menu" actionhandler={this.settingsclickHandler}>
								<IconSettings />
							</ControlButton>

							<div className="controls-flyup-menu format-picker">
								{ this.props.data.products.map((product, index) => {
									return(<FlyoutButton tabIndex="0" data={this.props.data} key={index} selected={this.props.data.currentProduct === index} option={index} clickHandler={this.settingsclickHandler}>
										<p><div className="visuallyhidden">{ this.props.data.currentProduct === index ? 'Currently selected:' : 'Switch to' } </div><span className="codec_name">{product.viewer_name}</span>
										<span className="codec_description">{product.codec_description}</span></p>
										</FlyoutButton>);
								})}
							</div>
						</div>

						: null
					}
				  </div>
				</div>
			</div>
		);
	}
}

class FlyoutThumbnailButton extends Component {
	constructor(props) {
		super(props);
		this.buttonRef = React.createRef();
	}

	mouseUpHandler = () => {
		// This is needed because the :focus state sticks when the mouse is used.
		// It is attached to the mouseup handler because we want focus to remain if the user is using alt-tab + enter to trigger clicks
		this.buttonRef.current.blur();
	}

	clickHandler = (ev) => {
		if (this.props.choice) {
			if (this.props.data.thumbnails && this.props.choice && this.props.data.selectedThumbnails[0] === this.props.choice[0] && this.props.data.selectedThumbnails[1] === this.props.choice[1]) {
				// active, don't send message
			} else {
				this.props.actionhandler(this.props.index);
			}

			// switch to a different slide
			this.props.updatePlayerState({
				selectedThumbnails: this.props.choice,
				thumbnails: true
			});
		} else {
			this.props.actionhandler();

			this.props.updatePlayerState({
				thumbnails: !this.props.showThumbnails
			});
		}
	}

	render() {
		var classes = 'flyoutbutton';

		if (this.props.data.thumbnails && this.props.choice && this.props.data.selectedThumbnails[0] === this.props.choice[0] && this.props.data.selectedThumbnails[1] === this.props.choice[1]) {
			classes += ' active';
		}

		return (
			<button ref={this.buttonRef} className={classes} onClick={this.clickHandler} onMouseUp={this.mouseUpHandler}>
				{this.props.children}
			</button>
		);
	}
}

let FlyoutButton = (props) => {
	const buttonRef = useRef(null);

	let mouseUpHandler = () => {
		// This is needed because the :focus state sticks when the mouse is used.
		// It is attached to the mouseup handler because we want focus to remain if the user is using alt-tab + enter to trigger clicks
		buttonRef.current.blur();
	}

	let clickHandler = (ev) => {
		props.clickHandler(props.option);
	}

	var classes = 'flyoutbutton';

	if (props.selected === true) {
		classes += ' active';
	}

	return (
		<button ref={buttonRef} className={classes} onClick={clickHandler} onMouseUp={mouseUpHandler}>
			{props.children}
		</button>
	);
}

let ControlButton = (props) => {
	const buttonRef = useRef(null);

	let mouseUpHandler = () => {
		// This is needed because the :focus state sticks when the mouse is used.
		// It is attached to the mouseup handler because we want focus to remain if the user is using alt-tab + enter to trigger clicks
		buttonRef.current.blur();
	}

	let clickHandler = (ev) => {
		if (props.disabled) {
			return;
		}

		if (props.actionValue) {
			props.actionhandler(props.actionValue);
		} else {
			props.actionhandler();
		}
	}

	var classes = 'controlbutton ' + props.className;

	if (props.selected) {
		classes += ' selected';
	}

	if (props.disabled) {
		classes += ' disabled';
	}

	let button = (
		<button
			ref={buttonRef}
			tabIndex={props.tindex}
			className={classes}
			title={props.tooltip ? undefined : props.title}
			aria-disabled={props.disabled ? 'true' : undefined}
			onMouseUp={mouseUpHandler}
			onClick={clickHandler}
		>
			{props.children}
		</button>
	);

	if (props.tooltip) {
		return (
			<div className="controlbutton-tooltip-container">
				{button}
				<div className="controlbutton-tooltip" role="tooltip">{props.tooltip}</div>
			</div>
		);
	}

	return button;
}


const mapStateToProps = (state) => ({
	dynamic: state.dynamic,
});

// FormattedTime is a functional component connected to dynamic state
const FormattedTime = connect(mapStateToProps)((props) => {
	return (
		<div className="controls-time">
			<span className="controls-current-time">{ props.dynamic.formattedTime }</span> / <span className="controls-duration">{props.data.formattedDuration}</span>
		</div>
	);
});

export default connect(mapStateToProps)(Controls);
